<template>
    <div class="lg:flex container mx-auto py-4 lg:space-x-4 px-2 md:px-0">
        <jet-form-main @submitted="jobCreate" class="lg:w-2/3">
            <template #title>
            </template>

            <template #description>
            </template>
            
            <template #form>
                <!-- Title -->
                <div>
                    <jet-label for="title" value="Título" class="font-bold" />
                    <jet-input type="text" v-model="form.title" class="w-full"/>
                    <jet-input-error :message="form.errors.title" />
                </div>

                <!-- regions -->
                <Regions v-if="job" @distrito='getResDistrito' @concelho='getResConcelho' @freguesia='getResFreguesia' class="mt-4" :resDistrito="job.distrito" :resConcelho="job.concelho" :resFreguesia="job.freguesia" />

                <Regions v-else @distrito='getResDistrito' @concelho='getResConcelho' @freguesia='getResFreguesia' class="mt-4" />
                <jet-input-error :message="form.errors.distrito" />
                <jet-input-error :message="form.errors.concelho" />
                <jet-input-error :message="form.errors.freguesia" />

                <!-- Description -->
                <div class="mt-4">
                    <jet-label for="description" value="Descrição" class="font-bold" />
                    
                    <text-area-input v-model="form.description" rows="4" class="w-full"></text-area-input>
                    <jet-input-error :message="form.errors.description" class="mt-2" />
                </div>
                <!-- Description -->
                <div class="flex mt-4 space-x-4">
                    <div class="flex-1">
                        <jet-label for="functions" value="Funções" class="font-bold" />
                        <text-area-input multi-line v-model="form.functions" rows="4" class="w-full"></text-area-input>
                        <jet-input-error :message="form.errors.functions" class="mt-2" />
                    </div>
                    <!-- Reqs -->
                    <div class="flex-1">
                        <jet-label for="reqs" value="Requisitos" class="font-bold" />
                        <text-area-input v-model="form.reqs" rows="4" class="w-full"></text-area-input>
                        <jet-input-error :message="form.errors.reqs" class="mt-2" />
                    </div>
                </div>
                <!-- Oferta -->
                <div class="mt-4">
                    <jet-label for="offers" value="Oferece-se" class="font-bold" />
                    <text-area-input v-model="form.offers" rows="4" class="w-full"></text-area-input>
                    <jet-input-error :message="form.errors.offers" class="mt-2" />
                </div>
                <!-- Notas -->
                <div class="mt-4">
                    <jet-label for="notes" value="Notas" class="font-bold" />
                    <text-area-input v-model="form.notes" rows="4" class="w-full"></text-area-input>
                    <jet-input-error :message="form.errors.notes" class="mt-2" />
                </div>

            </template>
        </jet-form-main>

        <div class="mt-1 lg:flex-1 relative h-full">
            <!-- categories -->
            <div class="px-4 py-5 bg-white sm:p-6 shadow rounded-md" v-if="categories.length">
                <h3 class="font-bold">Categoria</h3>

                <select v-model="form.category_id" class="border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm w-full mt-1">
                    <option value="" disabled>Categorias</option>
                    <option v-for="category in categories" :value="category.id">{{ category.name }}</option>
                </select>
                <jet-input-error :message="form.errors.category_id" />
            </div>
            <!-- email -->
            <div class="px-4 py-5 bg-white sm:p-6 shadow rounded-md mt-4">
                <jet-label for="email" value="Email de receção" class="font-bold" />
                <jet-input type="text" v-model="form.email_receiver" class="w-full"/>
                <jet-input-error :message="form.errors.email_receiver" />
                
            </div>
            <!-- candidatos -->
            <div class="px-4 py-5 bg-white sm:p-6 shadow rounded-md mt-4" v-if="job && job.candidatos">
                <h3 class="font-bold" v-if="job.candidatos.length">Candidatos</h3>
                <h3 class="text-gray-400" v-else><em>Sem candidatos</em></h3>
                <div v-for="candidato in job.candidatos" class="mt-2">
                    <div class="flex justify-between items-center">
                        <button @click.prevent="detachCandidato(candidato.id)"><icon name="close" class="w-4 h-4 text-red-400" /></button>
                        <p>{{ candidato.nome }}</p>
                        <p class="uppercase text-xs font-bold"><a :href="route('show.candidato', candidato.id)">Ver Perfil</a></p>
                    </div>
                    
                </div>
            </div>

            <div class="px-4 py-5 bg-white sm:p-6 shadow rounded-md mt-4">
                <div class="flex items-center space-x-2">
                    <label for="checked-toggle" class="inline-flex relative items-center cursor-pointer">
                       <!--  <jet-checkbox v-model="form.is_published" :checked="form.is_published == 1 ? true : false" id="checked-toggle" class="sr-only peer" />
                        <div class="w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-transparent dark:peer-focus:ring-violet-900 dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-violet-500"></div> -->
                        <jet-checkbox v-model="form.is_published" :checked="form.is_published == 1 ? true : false" id="checked-toggle" class="sr-only peer" />
                        <div class="w-11 h-6 bg-gray-100 rounded-full peer peer-focus:ring-4 peer-focus:ring-transparent peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-violet-500"></div>
                        <span class="ml-3 text-sm font-medium text-violet-500 dark:text-violet-100 uppercase" v-if="form.is_published == 1">Público</span>
                        <span class="ml-3 text-sm font-medium text-gray-300 dark:text-gray-300 uppercase" v-else>Rascunho</span>
                    </label>
                </div>

                <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="relative bottom-0 bg-primary-900 text-center w-full justify-center text-lg tracking-normal mt-10 rounded-full" @click.prevent="jobUpdate" v-if="job">Atualizar</jet-button>
                
                
                <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing" class="relative bottom-0 bg-primary-900 text-center w-full justify-center text-lg tracking-normal mt-10 rounded-full" @click.prevent="jobCreate" v-else>Criar</jet-button>

                <div class="flex justify-between mt-4">
                    <jet-button @click.prevent="backToJobs()" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-violet-500 px-0"><icon name="back" />Voltar</jet-button>

                    <jet-button v-if="job" @click.prevent="removeJob(job.slug)" class="bg-transparent hover:bg-transparent focus:bg-transparent active:bg-transparent border-0 active:border-0 focus:border-0 focus:ring-transparent active:shadow-0 focus:shadow-0 underline text-amber-600 px-0"><icon name="trash" class="w-3 h-3" /> Remover</jet-button>
                </div>
            </div>

        </div>

    </div>
</template>


<script>
    import { defineComponent } from 'vue'
    import BackLayout from '@/Layouts/BackLayout.vue'
    import { Head, Link } from '@inertiajs/inertia-vue3'
    import TextAreaInput from '@/Jetstream/TextAreaInput.vue'
    import JetActionMessage from '@/Jetstream/ActionMessage.vue'
    import JetButton from '@/Jetstream/Button.vue'
    import JetFormMain from '@/Jetstream/MainForm.vue'
    import JetInput from '@/Jetstream/Input.vue'
    import JetInputError from '@/Jetstream/InputError.vue'
    import JetLabel from '@/Jetstream/Label.vue'
    import JetModal from '@/Jetstream/Modal.vue'
    import JetCheckbox from '@/Jetstream/Checkbox.vue'
    import JetDialogModal from '@/Jetstream/DialogModal.vue'
    import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'
    import Icon from '@/Jetstream/Icon'
    import Regions from '@/Components/RegionsComp.vue'

    export default defineComponent({
        components: {
            Head,
            Link,
            JetInput,
            TextAreaInput,
            JetLabel,
            JetActionMessage,
            JetButton,
            JetFormMain,
            JetInputError,
            JetModal,
            JetCheckbox,
            JetDialogModal,
            JetSecondaryButton,
            Icon,
            Regions
        },
        layout: BackLayout,
        props: {
            canLogin: Boolean,
            canRegister: Boolean,
            laravelVersion: String,
            phpVersion: String,
            categories: Array,
            job: Object,
        },
        data() {
            return {
                showCatModal: false,
                form: this.$inertia.form({
                    title: '',
                    description: '',
                    functions: '',
                    reqs: '',
                    offers: '',
                    notes: '',
                    is_published: false,
                    category_id: '',
                    distrito: '',
                    concelho: '',
                    freguesia: '',
                    email_receiver: ''
                }),
                codeDistrito: '',
                codeConcelho: '',
                codeFreguesia: ''
            }
        },
        created() {
            if(this.job) {
                this.form.title = this.job.title
                this.form.description = this.job.description
                this.form.functions = this.job.functions
                this.form.reqs = this.job.reqs
                this.form.offers = this.job.offers
                this.form.notes = this.job.notes
                this.form.is_published = this.job.is_published
                this.form.category_id = this.job.category_id
                this.form.distrito = this.job.distrito
                this.form.concelho = this.job.concelho
                this.form.freguesia = this.job.freguesia
                this.form.email_receiver = this.job.email_receiver
            }
        },
        methods: {
            getResDistrito(e) {
                this.form.distrito = e
            },
            getResConcelho(e) {
              this.form.concelho = e
            },
            getResFreguesia(e) {
              this.form.freguesia = e
            },
            getCodeDistrito(e) {
                this.codeDistrito = e
            },
            getCodeConcelho(e) {
                this.codeConcelho = e
            },
            getCodeFreguesia(e) {
                this.codeFreguesia = e
            },
            jobCreate() {
                this.form.post(route('store.job'), {
                    errorBag: 'jobCreate',
                    preserveScroll: true,
                    onSuccess: () => this.form.reset(),
                    onError: () => {
                    }
                })
            },
            jobUpdate() {
                this.form.put(route('update.job', this.job.slug), {
                    errorBag: 'jobCreate',
                    preserveScroll: true,
                    onSuccess: () => this.job,
                    onError: () => {
                    }
                })
            },
            removeJob(job) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('destroy.job', job));
                }
            },
            backToJobs() {
                this.$inertia.get(route('jobs.index'))
            },
            detachCandidato(id) {
                if(confirm('Tem certeza? Esta ação é irreversível.')){
                    this.$inertia.delete(route('remover.candidato', {
                        'candidato_id': id,
                        'slug': this.job.slug
                }));
                }
            }
        },
    })
</script>